import React, { useEffect, useRef } from 'react';

const CurvedLines = ({ count = 5, color = 'white', opacity = 0.1, animate = true }) => {
  const canvasRef = useRef(null);
  
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const width = canvas.width = window.innerWidth;
    const height = canvas.height = window.innerHeight;

    const lines = [];

    for (let i = 0; i < count; i++) {
      lines.push({
        startX: Math.random() * width,
        startY: Math.random() * height,
        endX: Math.random() * width,
        endY: Math.random() * height,
        cp1x: Math.random() * width,
        cp1y: Math.random() * height,
        cp2x: Math.random() * width,
        cp2y: Math.random() * height,
        lineWidth: 0.5 + Math.random() * 2,
        speed: 0.0005 + Math.random() * 0.001,
        phase: Math.random() * Math.PI * 2,
      });
    }

    const drawLines = () => {
      ctx.clearRect(0, 0, width, height);
      
      lines.forEach(line => {
        if (animate) {
          line.phase += line.speed;
        }

        const offsetX = Math.sin(line.phase) * 100;
        const offsetY = Math.cos(line.phase) * 100;

        ctx.beginPath();
        ctx.moveTo(line.startX, line.startY);
        ctx.bezierCurveTo(
          line.cp1x + offsetX, line.cp1y + offsetY,
          line.cp2x - offsetX, line.cp2y - offsetY,
          line.endX, line.endY
        );

        ctx.strokeStyle = color;
        ctx.globalAlpha = opacity;
        ctx.lineWidth = line.lineWidth;
        ctx.stroke();
      });

      if (animate) {
        requestAnimationFrame(drawLines);
      }
    };

    drawLines();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      drawLines();
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      if (animate) {
        cancelAnimationFrame(drawLines);
      }
    };
  }, [count, color, opacity, animate]);
  
  return (
    <canvas 
      ref={canvasRef} 
      className="absolute inset-0 z-0 pointer-events-none"
      style={{ opacity: 0.8 }}
    />
  );
};

export default CurvedLines;